import React from "react";
import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from "react-icons/fa";

function MediaViewer({
  items,
  action,
  index,
}: {
  items: any[];
  action: () => void;
  index: number;
}) {
  const areaRef1 = React.useRef(null);
  const areaRef2 = React.useRef(null);
  const areaRef3 = React.useRef(null);

  const [currentIndex, setCurrentIndex] = React.useState(index);
  const [mediaType, setMediaType] = React.useState<string | null>(null);

  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        areaRef1.current &&
        !areaRef1.current.contains(event.target) &&
        areaRef2.current &&
        !areaRef2.current.contains(event.target) &&
        areaRef3.current &&
        !areaRef3.current.contains(event.target)
      ) {
        action();
      }
    };

    const handleEscapePress = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        action();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapePress);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapePress);
    };
  }, [action]);

  React.useEffect(() => {
    // Detecta o tipo do item atual (imagem ou vídeo)
    const detectBlobType = async (blobUrl: string) => {
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      const contentType = blob.type;

      if (contentType.startsWith('image/')) {
        setMediaType('image');
      } else if (contentType.startsWith('video/')) {
        setMediaType('video');
      } else {
        setMediaType('unknown');
      }
    };

    detectBlobType(items[currentIndex]).catch((error) => {
      console.error("Erro ao detectar tipo:", error);
    });
  }, [currentIndex, items]);

  const handleUserAction = (action: "previous" | "next") => {
    setCurrentIndex((prevIndex) => {
      if (action === "previous") {
        return prevIndex === 0 ? items.length - 1 : prevIndex - 1;
      } else {
        return prevIndex === items.length - 1 ? 0 : prevIndex + 1;
      }
    });
  };

  return (
    <div
      style={{
        background: "#131313a8",
        width: "100vw",
        height: "100vh",
        position: "fixed",
        zIndex: "100",
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="d-flex align-items-center justify-content-center gap-5">
        <div ref={areaRef2}>
          {/* <FaArrowAltCircleLeft
            size={32}
            color="white"
            onClick={() => handleUserAction("previous")}
            className="pointer"
          /> */}
        </div>

        <div
          style={{
            maxWidth: "80%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
          ref={areaRef1}
        >
          {mediaType === "image" ? (
            <img
              src={items[currentIndex]}
              alt={`imagem-${currentIndex}`}
              width={"100%"}
              style={{ userSelect: "none", objectFit: "contain" }}
            />
          ) : mediaType === "video" ? (
            <video controls>
              <source
                src={items[currentIndex]}
                type="video/mp4"
                style={{ userSelect: "none", objectFit: "contain" }}
              />
              Seu navegador não suporta o vídeo.
            </video>
          ) : null}
        </div>

        <div ref={areaRef3}>
          {/* <FaArrowAltCircleRight
            size={32}
            color="white"
            onClick={() => handleUserAction("next")}
            className="pointer"
          /> */}
        </div>
      </div>
    </div>
  );
}

export default MediaViewer;
